import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Fonts are served from our own servers (no Google Fonts calls, so no visitor data leaves the UK for them).
import "@fontsource-variable/montserrat/wght.css";
import "@fontsource/jetbrains-mono/latin-400.css";
import "@tc/ui/tokens.css";
import "@tc/ui/ui.css";
import "./app.css";
import { App } from "./App.js";
import { PageError } from "./PageError.js";
import { markEnvironment } from "./envmark.js";
import { watchKeyboard } from "./keyboard.js";
createRoot(document.getElementById("root")!).render(<StrictMode><PageError where="app"><App /></PageError></StrictMode>);
// The sandbox marks itself (tab title, amber icon, a stripe at the top); live never does (19/10/26).
void markEnvironment();
// The bottom bar steps aside for the phone's keyboard and never sticks half-way up the page after it (24/10/26).
watchKeyboard();

// The opening splash (index.html) stays until the first real screen is drawn: App calls splashDone() once the
// sign-in page or the company app (not a loading screen) is on screen. It always holds the last word, "Simplified.", for 1.5s.
